export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      functions: [
        {
          functionMstId: 5,
          functionMstUuid: "functionmst005",
          functionName: "ビデオチャット機能",
        },
        {
          functionMstId: 4,
          functionMstUuid: "functionmst004",
          functionName: "警戒レベル告知機能",
        },
        {
          functionMstId: 3,
          functionMstUuid: "functionmst003",
          functionName: "スマホ連携機能",
        },
        {
          functionMstId: 2,
          functionMstUuid: "functionmst002",
          functionName: "御用聞き機能",
        },
        {
          functionMstId: 1,
          functionMstUuid: "functionmst001",
          functionName: "見守り機能",
        }
      ]
    }
  }
}